<template>
  <v-container fluid grid-list-md>
    <!-- dialog para inserção de senha -->
    <p-file-password-dialog ref="pDelete" :clearPassword="clearPassword" :loading="fileLoading" :dialog="passDialog" @passChangeConfirm="(pass) => {passChangeConfirm(pass)}" @passChangeCancel="passChangeCancel"></p-file-password-dialog>
    <v-layout wrap justify-center align-center>
      <v-flex xs12>
        <vue-dropzone id="dropzone" :options="dropOptions" ref="dropzone" v-on:vdropzone-sending="sendingEvent"
                      v-on:vdropzone-success="successEvent" v-if="checkPermission(this.entity, 'create')"
                      v-on:vdropzone-error="errorEvent" v-on:vdropzone-file-added="fileAdded"></vue-dropzone>
        <v-card color="cyan" v-else>
          <div class="vue-dropzone dropzone"><div class="dz-default dz-message"><span>&nbsp;Você não tem permissão para incluir arquivos!</span></div></div>
        </v-card>
      </v-flex>
      <v-flex xs12 sm8>
        <span class="headline"><v-icon large class="mr-1" color="primary">{{this.translate(`table.${this.entity}.icon`)}}</v-icon>{{formTitle}}</span>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <p-filter
          ref="filter"
          :allItems="allItems"
          :entity="entity"
          :filterTypes="filterTypes"
          @customFilter="(res)=>{items=res}">
        </p-filter>
      </v-flex>
      <!--Dialog para confirmação de exclusão-->
      <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.' + entity + '.title')[1]" :dialog="dialogConfirm" @confirm="(tempDeletedItem.user_id === $auth.user().id || tempDeletedItem.password === null) ? processDelete(tempDeletedItem) : initPassDialog(tempDeletedItem, 2, 2)" @cancel="closeDialogDelete"></p-confirm>
      <!--Index-->
      <v-flex xs12>
        <v-data-table
          :no-data-text="emptyTable"
          rows-per-page-text="Registros por página"
          :headers="headers"
          :items="items"
          :search="search"
          class="elevation-1"
          :pagination.sync="pagination"
          :rows-per-page-items="[25,50,100,{'text':'Todos','value':-1}]"
          :custom-filter="customizedFilter" style="word-break: break-all;">
          <template slot="items" slot-scope="props">
            <td>{{ `${props.item.id_text}.${props.item.extension}` }}</td>
            <td>{{ props.item.size ? (props.item.size / 1000000).toFixed(2)+' MB' : ''}}</td>
            <td v-if="props.item.source === 2">
              <v-tooltip top v-if="props.item.task_file">
                <router-link slot="activator" :to="`task/${props.item.task_id}?return=files`">{{ translate('table.' + entity + '.field.task_id') + '-' + props.item.task_file.identifier_sequence }}</router-link>
                <span>{{props.item.task_file.id_text}}</span>
              </v-tooltip>
            </td>
            <td v-else>Arquivo</td>
            <td>{{ props.item.user_id ? props.item.user.id_text : ''}}</td>
            <td>{{ props.item.task_file && props.item.task_file.client_id? props.item.task_file.client.id_text : ''}}</td>
            <td>{{ props.item.created_at | formatDate}}</td>
            <td align="center" style="min-width: 182px">
              <v-tooltip bottom>
                <v-btn icon slot="activator" class="mx-0">
                  <v-icon color="grey darken-1">list</v-icon>
                </v-btn>
                <span>
                  <!--usado o dialog para que o other field seja recarregado quando for feito alguma alteração-->
                  <p-other-field v-if="!dialog" :othersFields="othersFields(props.item)"></p-other-field>
                </span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-progress-circular
                  slot="activator"
                  v-if="props.item.loading_view"
                  :value="props.item.loading_value_view"
                  color="teal"
                >{{ props.item.loading_value_view }}</v-progress-circular>
                <v-btn :disabled="!'pdf.png.jpeg.jpg.ico.txt.sql'.includes(props.item.extension)" slot="activator" v-else icon class="mx-0" @click="props.item.user_id === $auth.user().id || props.item.password === null ? downloadItem(props.item, '', true) : initPassDialog(props.item, 4)">
                  <v-icon color="teal">visibility</v-icon>
                </v-btn>
                <span v-if="'pdf.png.jpeg.jpg.ico.txt.sql'.includes(props.item.extension)">Visualizar</span>
                <span v-else>Não é possível visualizar esse arquivo</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-progress-circular
                  slot="activator"
                  v-if="props.item.loading_download"
                  :value="props.item.loading_value_download"
                  color="deep-purple"
                >{{ props.item.loading_value_download }}</v-progress-circular>
                <v-btn slot="activator" v-else icon class="mx-0" @click="props.item.user_id === $auth.user().id || props.item.password === null ? downloadItem(props.item) : initPassDialog(props.item, 4)">
                  <v-icon color="deep-purple">cloud_download</v-icon>
                </v-btn>
                <span>Baixar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn :disabled="$auth.user().id !== props.item.user_id  || !checkPlanAccess('files_password', 'has')" slot="activator" icon class="mx-0" @click="initPassDialog(props.item, 3, 1, (props.item.password !== null))">
                  <v-icon color="black">{{props.item.password !== null ? 'lock' : 'lock_open'}}</v-icon>
                </v-btn>
                <span>{{!checkPlanAccess('files_password', 'has') ? 'Seu plano não tem acesso aos arquivos com senha' : $auth.user().id === props.item.user_id ? (props.item.password === null ? 'Incluir Senha' : 'Alterar Senha') : (props.item.password === null ? 'Somente quem adicionou o arquivo pode incluir a senha' : 'Somente quem adicionou o arquivo pode alterar a senha')}}</span>
              </v-tooltip>
              <v-menu
                left
                nudge-top="8"
                content-class="elevation-0 menu_content"
                transition="slide-x-reverse-transition"
                :offset-x="true"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :id="'file_more_btn'+props.index" fab small slot="activator" v-on="on" icon class="mx-0">
                    <v-icon medium>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-tooltip bottom>
                  <v-btn :id="'file_edit_btn'+props.index" slot="activator" small fab class="mx-0" @click="processEditItem(props.item)" :disabled="!checkPermission(entity, 'edit')">
                    <v-icon color="teal">edit</v-icon>
                  </v-btn>
                  <span>{{editTooltipText}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn :id="'file_delete_btn'+props.index"  slot="activator" small fab class="mx-0" @click="beforeDialogDelete(props.item)" :disabled="!checkPermission(entity, 'delete')">
                    <v-icon color="pink">delete</v-icon>
                  </v-btn>
                  <span>{{deleteTooltipText}}</span>
                </v-tooltip>
              </v-menu>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <!--foi colocado o v-if="dialog" porque o pselecteditable carregava antes da requisição ser feita, então o campo vinha vazio mesmo tendo registros-->
    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
      <v-card>
        <v-card-title primary-title>
          <span class="headline"><v-icon large class="mr-1" color="primary">{{this.translate(`table.${this.entity}.icon`)}}</v-icon>{{formTitle}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="valid" ref="form">
            <v-container grid-list-md>
              <v-layout wrap justify-center align-center>
                <v-flex xs12>
                  <v-text-field maxlength="190" counter="190"  ref="autofocus" :rules="requiredFileNameRule(translate('table.' + entity + '.field.id_text'))" @keyup.native.esc="close(400)" :label="translate('table.' + entity + '.field.id_text')"
                                v-model="editedItem.id_text" @keyup.native.ctrl.enter="save()"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <p-select-modal-editable id="taskfile_category_id"
                  :showActions="editedItem.company_id === $auth.user().company_id" :clearable="false" :label="translate('table.' + entity + '.field.category_id')" @change="(id, item) => {editedItem['category'] = item}" v-model="editedItem.category_id" entity="select_editable" :values="category_fields" :selectedItem="editedItem.category">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex>
                        <v-text-field id="modalfocus" v-model="category_fields.id_text" :label="translate('table.task_status.field.id_text')"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </p-select-modal-editable>
                </v-flex>
                <v-flex xs12 sm6>
                  <p-select-modal-editable id="taskfile_subcategory_id"
                  :showActions="editedItem.company_id === $auth.user().company_id" :clearable="false" :label="translate('table.' + entity + '.field.subcategory_id')" @change="(id, item) => {editedItem['subcategory'] = item}" v-model="editedItem.subcategory_id" entity="select_editable" :values="subcategory_fields"  :selectedItem="editedItem.subcategory">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex>
                        <v-text-field id="modalfocus" v-model="subcategory_fields.id_text" :label="translate('table.task_status.field.id_text')"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </p-select-modal-editable>
                </v-flex>
                <v-flex xs12 sm6>
                  <p-date :label="translate('table.' + entity + '.field.emission')"
                          v-model="editedItem.emission" :rules="dateDiffRule(false, 'data', editedItem.emission, editedItem.maturity)" @keyup.native.ctrl.enter="save()"></p-date>
                </v-flex>
                <v-flex xs12 sm6>
                  <p-date :label="translate('table.' + entity + '.field.maturity')"
                          :rules="dateDiffRule(false, 'data', editedItem.emission, editedItem.maturity)" v-model="editedItem.maturity" @keyup.native.ctrl.enter="save()"></p-date>
                </v-flex>
                <v-flex xs12>
                  <v-textarea @keyup.native.esc="close(400)" :label="translate('table.' + entity + '.field.note')" @keyup.native.ctrl.enter="save()"
                              v-model="editedItem.note"></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="file_save_btn" class="mx-0" color="primary darken-2" :loading="loading" @click.native="save()">Salvar</v-btn>
          <v-btn id="file_close_btn" class="mx-0" @click.native="close(400)">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style>
  .dz-preview {
    z-index: 0;
  }
  .menu_content {
    padding: 0 10px 10px 10px;
  }
  .speed-dial {
    display: inline !important;
  }
</style>

<script>
  import socket from '../mixin/socket'
  import crud from '../mixin/crud'
  import rules from '../mixin/rules'
  import tooltip from '../mixin/tooltip'
  import vueDropzone from 'vue2-dropzone'
  import moment from 'moment'
  import PDate from './shared/PDate'
  import PFilePasswordDialog from './shared/PFilePasswordDialog.vue'
  import PFilter from './shared/PFilter'
  import PSelectModalEditable from './shared/PSelectModalEditable'
  import POtherField from './shared/POtherField'
  import PConfirm from './shared/PConfirm'

  export default {
    components: {
      vueDropzone, PFilePasswordDialog, PDate, PFilter, PSelectModalEditable, POtherField, PConfirm
    },
    mixins: [crud, rules, socket, tooltip],
    data: () => ({
      entity: 'files',
      category_fields: {},
      subcategory_fields: {},
      delete_text: '',
      actAfterPassword: 1,
      tempDeletedItem: {},
      deletepass: '',
      fileLoading: false,
      tempItem: {},
      passDialog: false,
      beforePassword: null,
      clearPassword: false,
      categories: [],
      subcategories: [],
      password: '',
      pagination: {
        sortBy: 'created_at'
      },
      dropOptions: {
        headers: {'Authorization': 'Bearer ' + localStorage.getItem('auth_token_default')},
        maxFilesize: 2048,
        timeout: 3600000,
        url: `${process.env.API}api/files`,
        thumbnailWidth: 100,
        thumbnailHeight: 100,
        maxThumbnailFilesize: 100,
        dictDefaultMessage: '<i class="fa fa-cloud"></i>\t&nbspSolte os arquivos aqui ou clique para salvá-los',
        dictFileTooBig: 'O upload não pôde ser efetuado, por favor insira arquivos de até 2GB',
        addRemoveLinks: true,
        dictCancelUpload: 'Cancelar',
        dictUploadCanceled: 'Upload cancelado!',
        dictCancelUploadConfirmation: 'Tem certeza que deseja cancelar este upload?',
        dictRemoveFile: 'Remover',
        dictRemoveFileConfirmation: null
      }
    }),
    name: 'File',
    props: ['task', 'values'],
    created () {
      this.$store.commit('loader/change_dialog', true)
      this.editedItem = {task_id: null, id_text: '', extension: null, category: {}, category_id: null, subcategory: {}, subcategory_id: null, emission: '', maturity: ''}
      this.defaultItem = {task_id: null, id_text: '', extension: null, category: {}, category_id: null, subcategory: {}, subcategory_id: null, emission: '', maturity: ''}
      this.category_fields = {id_text: '', active: true, type: 'file_category', company_id: this.$auth.user().company_id}
      this.subcategory_fields = {id_text: '', active: true, type: 'file_subcategory', company_id: this.$auth.user().company_id}

      this.initialize()
      this.pagination.descending = !this.pagination.descending
    },
    mounted () {
      this.$socket.emit('joinRoom', {room: `${this.socketRoom}`})
    },
    methods: {
      afterInitialize (values, items) {
        this.redoFilter(values)

        this.categories = []
        this.items.forEach((item) => {
          if (item['category']) this.categories.push({id: item['category']['id'], id_text: item['category']['id_text']})
        })
        this.subcategories = []
        this.items.forEach((item) => {
          if (item['subcategory']) this.subcategories.push({id: item['subcategory']['id'], id_text: item['subcategory']['id_text']})
        })
        // busca para o filtro
      },
      // deletar varios registros de uma vez, para quando uma tarefa for deletada
      processDelete (item) {
        this.editedItem = item
        this.deleteItem()
      },
      beforeDeleteSocketItem (item) {
        if (item.many === true) {
          this.allItems.forEach(el => {
            if (el.task_id === item.task_id) {
              this.allItems.splice(this.allItems.indexOf(el))
            }
          })
          this.items.forEach(el => {
            if (el.task_id === item.task_id) {
              this.items.splice(this.items.indexOf(el))
            }
          })
          this.redoFilter()
          return false
        }
      },
      processEditItem (item) {
        this.tempItem = item
        if (item.password === null) {
          delete this.editedItem.password
          this.editItem(item)
        } else {
          this.$http.get(`api/getFilePassword?id=${item.id}`).then(res => {
            delete this.editedItem.password
            this.editItem(item)
          }, err => {
            console.log(err)
            this.initPassDialog(item, 2, 3)
          })
        }
      },
      beforeDialogDelete (item) {
        if (item.task_id != null) {
          this.delete_text = 'O arquivo também será excluído da tarefa de origem, tem certeza que deseja excluí-lo'
        } else {
          this.delete_text = 'Tem certeza que deseja excluir esse arquivo'
        }
        this.tempDeletedItem = item
        this.dialogDelete(item)
      },
      afterUpdate (file) {
        // Enviando evento para o servidor Socket
        this.$socket.emit('generalEvent', {
          data: file,
          responseEvent: 'editSocketItem',
          room: this.socketRoom
        })
        if (file.task_id) {
          // Enviando evento para editar o registro na aba de arquivos nos detalhes da tarefa
          this.$socket.emit('generalDetailsEvent', {
            data: file,
            details: 'files',
            responseEvent: 'editSocketDetails',
            room: `tasks${file.task_id}_manage`
          })
        }
        this.$socket.emit('generalEvent', {
          data: {values: file, entity: 'arquivo'},
          responseEvent: 'editSocketManagementDetails',
          room: `files${file.id}_manage`
        })
      },
      initPassDialog (item, view = 3, after = 1, clear = false) {
        if (clear) this.clearPassword = true
        this.passDialog = true
        this.view = view
        this.dialogConfirm = false
        this.actAfterPassword = after
        this.editedItem = {id: item.id, task_id: item.task_id, id_text: item.id_text, extension: item.extension}
        if (view === 3) {
          if (item.password === null) this.password = ''
          else {
            this.fileLoading = true
            this.$http.get(`api/getFilePassword?id=${item.id}`).then(res => {
              this.editedItem.password = res.body
              this.password = this.editedItem.password === null ? '' : atob(this.editedItem.password)
              this.$refs.pDelete.password = this.password
            })
            this.fileLoading = false
          }
        }
      },
      passChangeConfirm (pass) {
        if (this.view === 3) {
          if (pass !== '') {
            this.editedItem.password = btoa(pass)
          } else {
            this.editedItem.password = null
          }
          // this.editedItem.password = this.password === '' ? null : btoa(JSON.parse(JSON.stringify(this.password)))
          this.save()
        } else {
          this.deletepass = btoa(pass)
          if (this.actAfterPassword === 1) this.downloadItem(this.editedItem, pass)
          if (this.actAfterPassword === 2) this.deleteItem(`?password=${this.deletepass}`)
          if (this.actAfterPassword === 3) {
            this.$http.get(`api/checkFilePassword?id=${this.editedItem.id}&password=${btoa(pass)}`).then(res => {
              delete this.editedItem.password
              this.editItem(this.tempItem)
            }, err => {
              console.log(err)
              this.$store.commit('snackbar/change_values', {
                text: 'Senha invalida!',
                color: 'warning',
                dialog: true
              })
            })
          }
        }
        this.password = ''
        this.passDialog = false
        this.clearPassword = false
      },
      passChangeCancel () {
        this.password = ''
        this.passDialog = false
        this.clearPassword = false
      },
      afterDelete (file) {
        // Enviando evento para o servidor Socket
        this.$socket.emit('generalEvent', {
          data: file,
          responseEvent: 'deleteSocketItem',
          room: this.socketRoom
        })
        if (file.task_id) {
          // Enviando evento para excluir o registro da aba de arquivos nos detalhes da tarefa
          this.$socket.emit('generalDetailsEvent', {
            data: file,
            details: 'files',
            responseEvent: 'deleteSocketDetails',
            room: `tasks${file.task_id}_manage`
          })
          // Emitindo evento para deletar arquivo no campo personalizado
          this.$socket.emit('generalEvent', {
            data: file,
            responseEvent: 'deleteFileCustomField',
            room: `tasks${file['task_id']}_manage`
          })
        }
        // socket para recarga de pagina na edição de item
        this.$socket.emit('generalEvent', {
          data: {text: 'Este Arquivo foi deletado, por favor recarregue a página para não haver conflitos.'},
          responseEvent: 'reloadPageModules',
          room: `files${file.id}_manage`
        })
        this.$socket.emit('generalEvent', {
          data: {entity: this.entity},
          responseEvent: 'socketCloseDialog',
          room: `files${file.id}_manage`
        })
        this.delete_text = ''
      },
      // quando um arquivo é adicionado a fila de espera ele deve ficar sem botão mas a sua tag n pode ser removida do html
      fileAdded (file) {
        const removeButton = file.previewElement.querySelector('.vue-dropzone.dropzone.dz-clickable.dz-started a')
        removeButton.className = ''
        removeButton.innerHTML = ''
        removeButton.href = ''
      },
      sendingEvent (file, xhr, formData) {
        var _this = this
        // recebe a referencia do botão de remover
        const removeButton = file.previewElement.querySelector('.vue-dropzone.dropzone.dz-clickable.dz-started a')
        // prepara a função de timeout, quando acontecer um timeout ou seja, atingir o limite de tempo para upload o processo abaixo acontece
        xhr.ontimeout = function (e) {
          // busca o botão de span para futuramente alterar seu texto
          const element = file.previewElement.querySelector('.dz-error-message span')
          element.textContent = 'Tempo limite de upload expirado!'
          file.previewElement.className = 'dz-preview dz-file-preview dz-error dz-complete'
          // chama um snackbar para alertar os usuarios
          _this.$store.commit('snackbar/change_values', {
            text: 'O arquivo ' + file.name + ' atingiu o tempo limite de upload!',
            color: 'error',
            dialog: true,
            timeout: 7000
          })
          // finalmente remove o botão
          removeButton.remove()
        }
        // retorna o template css para o botão de remover
        removeButton.className = 'dz-remove'
        formData.append('user_id', this.$auth.user().id)
        formData.append('company_id', this.$auth.user().company_id)
      },
      beforeEditItem (item) {
        this.$socket.emit('joinRoom', {room: `files${item.id}_manage`})
      },
      afterClose (oldValues) {
        this.$socket.emit('leaveRoom', {room: `files${oldValues.id}_manage`})
      },
      successEvent (file, xhr, formData) {
        this.items.unshift(xhr)
        this.allItems.unshift(xhr)
        this.$store.commit('snackbar/change_values', {text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' incluído com sucesso!', color: 'success', dialog: true})
        // Enviando evento para o servidor Socket
        this.$socket.emit('generalEvent', {
          data: xhr,
          responseEvent: 'addSocketItem',
          room: this.socketRoom
        })
        const removeButton = file.previewElement.querySelector('.vue-dropzone.dropzone.dz-clickable.dz-started a')
        removeButton.remove()
      },
      errorEvent (file, error, xhr) {
        // existem dois tipos de erros, os que retornam string e os que retornam objetos
        if (typeof error === 'string') {
          // tratamento de erro caso o servidor caia
          if (error.indexOf('responded with 0 code') !== -1) {
            const elements = document.querySelectorAll('.dz-error-message span')
            elements.forEach((val) => {
              if (val.textContent.indexOf('responded with 0 code.') !== -1) val.textContent = 'O servidor não está respondendo, cheque sua conexão com a internet!'
            })
            this.$store.commit('snackbar/change_values', {
              text: 'O servidor não está respondendo, cheque sua conexão com a internet!',
              color: 'error',
              timeout: 7000,
              dialog: true
            })
            return
            // tratamento de erro caso o arquivo seja muito grande
          } else if (error.indexOf('arquivos de até 2GB') !== -1) {
            this.$store.commit('snackbar/change_values', {
              text: `O upload não pôde ser efetuado, por favor insira arquivos de até 2GB!`,
              color: 'error',
              dialog: true
            })
            return
          }
        } else if (error.message.includes('limit|')) {
          // tratamento de erro caso o limite do plano seja atingido
          this.$store.commit('snackbarPlan/change_values', {
            text: `Não foi possível incluir o arquivo!`,
            dialog: true
          })
          // busca a memoria do plano do usuário
          let sizePlan = this.getterAccesses.find((res) => {
            return (res.id_text === 'files' && res.hasOwnProperty('size'))
          })
          // caso não tenha a variavel de tamanho, insere 0
          sizePlan = !sizePlan ? 0 : sizePlan['size']
          // transforma bit em mb
          let sumSizeFiles = (parseInt(sizePlan) - parseInt(error.message.split('|')[1])) / 1000000
          this.$store.commit('dialogPlan/change_values', {
            title: 'Memória excedida',
            text: `Esse arquivo ultrapassa o limite do seu plano, você tem apenas <strong>${Math.round(sumSizeFiles)}mb disponível</strong>. Aproveite e faça o upgrade agora mesmo!`,
            showDialog: true
          })
          // caso o usuario não tenha permissões sobre o arquivo
        } else if (error.message.indexOf('stream: Permission denied') !== -1) {
          const elements = document.querySelectorAll('.dz-error-message span')
          elements.forEach((val) => {
            if (val.textContent === '[object Object]') val.textContent = 'Não foi possivel obter permissão do sistema para inserir este arquivo!'
          })
          this.$store.commit('snackbar/change_values', {
            text: `Não foi possivel obter permissão do sistema para inserir este arquivo!`,
            coloc: 'error',
            dialog: true
          })
        }
        this.$store.commit('snackbar/change_values', {text: 'Não foi possível incluir o registro de ' + this.translate('table.' + this.entity + '.title')[0] + '.', color: 'error', dialog: true})
        const removeButton = file.previewElement.querySelector('.vue-dropzone.dropzone.dz-clickable.dz-started a')
        removeButton.remove()
      },
      downloadItem (item, password = '', onlyView = false) {
        this.onlyView = onlyView
        // seta true para o loading começar a rodar
        this.$set(item, `loading_${onlyView ? 'view' : 'download'}`, true)
        this.$set(item, `loading_value_${onlyView ? 'view' : 'download'}`, 0)
        this.$http.get(`api/${this.entity}/download/${item.id}?${item.task_id !== null ? `task=${item.task_id}&` : ''}shared=${false}${password === '' ? '' : `&password=${btoa(password)}`}`, {
          responseType: 'arraybuffer',
          progress (e) {
            if (e.lengthComputable) {
              item[`loading_value_${onlyView ? 'view' : 'download'}`] = Math.floor(e.loaded / e.total * 100)
            }
          }
        }).then(res => {
          let blob = new Blob([res.data], {type: res.headers.get('content-type')})
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          if (onlyView) {
            window.open(link, '_blank')
          } else {
            link.download = item.id_text + '.' + item.extension
            link.click()
          }
          item[`loading_${onlyView ? 'view' : 'download'}`] = false
        }, err => {
          console.log(err)
          item[`loading_${onlyView ? 'view' : 'download'}`] = false
          if (err.status === 400) {
            this.$store.commit('snackbar/change_values', {
              text: 'Senha invalida!',
              color: 'warning',
              dialog: true
            })
          }
        })
      },
      othersFields (item) {
        return [
          {field: this.translate('table.' + this.entity + '.field.category_id'), value: item.category ? item.category.id_text : ''},
          {field: this.translate('table.' + this.entity + '.field.subcategory_id'), value: item.subcategory ? item.subcategory.id_text : ''},
          {field: this.translate('table.' + this.entity + '.field.emission '), value: item.emission ? moment(String(item.emission)).format('DD/MM/YYYY') : ''},
          {field: this.translate('table.' + this.entity + '.field.maturity '), value: item.maturity ? moment(String(item.maturity)).format('DD/MM/YYYY') : ''},
          {field: this.translate('table.' + this.entity + '.field.extension'), value: item.extension ? item.extension : ''},
          {field: this.translate('table.' + this.entity + '.field.note '), value: item.note ? item.note : ''}
        ]
      }
    },
    computed: {
      sumSize: function () {
        return this.items.reduce((value, nextValue) => {
          return value + nextValue.size
        }, 0)
      },
      filterTypes: function () {
        return [
          {field: 'id_text', type: 'string'},
          {field: 'source', type: 'array', items: this.translate('value.file_source')},
          {field: 'extension', type: 'string'},
          {field: 'emission', type: 'date'},
          {field: 'maturity', type: 'date'},
          {field: 'category_id', type: 'array', items: this.categories, text: 'id_text', value: 'id'},
          {field: 'subcategory_id', type: 'array', items: this.subcategories, text: 'id_text', value: 'id'},
          {field: 'note', type: 'string'}
        ]
      },
      headers: function () {
        return [
          {text: this.translate('table.' + this.entity + '.field.id_text'), value: 'id_text', width: '25%'},
          {text: this.translate('table.' + this.entity + '.field.size'), value: 'size', width: '5%'},
          {text: this.translate('table.' + this.entity + '.field.source'), value: 'source', width: '15%'},
          {text: this.translate('table.' + this.entity + '.field.user_id'), value: 'user.id_text', width: '20%'},
          {text: this.translate('table.tasks.field.client_id'), value: 'task_file.client.id_text', width: '15%'},
          {text: this.translate('table.' + this.entity + '.field.created_at'), value: 'created_at', width: '10%'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center'}
        ]
      }
    },
    destroyed () {
      this.$socket.emit('leaveRoom', {room: this.socketRoom})
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/File.vue